import "./i18n/config";
import "./main.scss";

import React from "react";
import ReactDOM from "react-dom";
import { MsalProvider } from "@azure/msal-react";
import MsalFactory from "factories/msalFactory";
import ErrorDisplay from "error/components/errorDisplay/errorDisplay";
import TranslationMapper from "i18n/mapper";
import { BrowserRouter as Router } from "react-router-dom";
import { register } from "./registerServiceWorker";
import AppEventHub from "utils/appEventHub";
import { registerGlobalErrorHandlers } from "services/globalErrorHandlers";

import ReactNotification from "components/notifications/reactNotification";
import { StyleUtils } from "utils/styleUtils";
import LoggedInCheck from "components/loggedInCheck/loggedInCheck";
import { NotificationContainer } from "react-notifications";

import ErrorBoundary from "./error/components/errorBoundary/errorBoundary";
import TelemetryProvider from "./providers/telemetryProvider";

AppEventHub.initialize();
MsalFactory.build();
registerGlobalErrorHandlers();
initializeServiceWorker();
StyleUtils.maintainViewportSize();
ReactNotification.manageNotifications();

MsalFactory.initialize()
  .then(() => {
    MsalFactory.getMsalInstance()
      .handleRedirectPromise()
      .then(() => {
        ReactDOM.render(
          <MsalProvider instance={MsalFactory.getMsalInstance()}>
            <Router>
              <ErrorBoundary>
                <TelemetryProvider>
                  <NotificationContainer />
                  <LoggedInCheck />
                </TelemetryProvider>
              </ErrorBoundary>
            </Router>
          </MsalProvider>,
          document.getElementById("root")
        );
      })
      .catch((error) => {
        renderLoginFailed();
      });
  })
  .catch((error) => {
    renderError();
  });

function renderLoginFailed(): void {
  ReactDOM.render(
    <Router>
      <ErrorDisplay
        errorTitle={TranslationMapper.global.errors.failed_login_title}
        errorText={TranslationMapper.global.errors.failed_login_text}
        errorCode="0x1BA1"
      />
    </Router>,
    document.getElementById("root")
  );
}

function renderError(): void {
  ReactDOM.render(
    <Router>
      <ErrorDisplay
        errorTitle={TranslationMapper.global.errors.browser_specific_error_title}
        errorText={TranslationMapper.global.errors.browser_specific_error_text}
        errorCode="0x4B9A"
      />
    </Router>,
    document.getElementById("root")
  );
}

function initializeServiceWorker(): void {
  register();
}
